// extracted by css-extract-rspack-plugin
export default {"closeIconWrapper":"_88448c41","colorDot":"_6fe19f4d"};